import { apiUrlECommerce } from "~constants";
import Network from "~helpers/Network";

import * as at from "./actionTypes";

export const setECommerceList = (payload) => ({
  type: at.SET_ECOMMERCE_LIST,
  payload,
});

export const setECommerceDataSourceList = (payload) => ({
  type: at.SET_ECOMMERCE_DATA_SOURCE_LIST,
  payload,
});

// ----------------- API -----------------

export const getECommerceList = (projectId) => () => {
  const url = `${apiUrlECommerce.get.format(projectId)}`;

  return Network.request(url, {
    onSuccess: (response) => setECommerceList(response?.results || []),
    loading: true,
  });
};
export const createOrUpdateECommerceIntegration =
  (projectId, data, options = {}) =>
  () => {
    const id = data?.id;
    const url = id ? `${apiUrlECommerce.get.format(projectId)}${id}/` : apiUrlECommerce.get.format(projectId);

    return Network.request(url, {
      method: id ? "PUT" : "POST",
      data,
      loading: true,
      successMsg: true,
      ...options,
    });
  };

export const testECommerceIntegration = (projectId, integrationId) => () => {
  const url = `${apiUrlECommerce.testIntegration.format(projectId, integrationId)}`;

  return Network.request(url, {
    loading: true,
  });
};

export const runIntegrationConnectionTests = (projectId) => () => {
  const url = `${apiUrlECommerce.getIntegrationAction.format(projectId)}`;
  return Network.request(url, {
    method: "POST",
    loading: true,
    successMsg: true,
  });
};

export const getECommerceIntegrationDataSourceList = (projectId) => () => {
  const url = `${apiUrlECommerce.getDataSource.format(projectId)}`;

  return Network.request(url, {
    loading: true,
    onSuccess: (response) => setECommerceDataSourceList(response?.results || []),
  });
};

//#region Shopify actions

export const checkShopifyIntegration =
  (queryParams, options = {}) =>
  () => {
    const url = `${apiUrlECommerce.checkShopifyIntegration}/`;
    const params = new URLSearchParams(queryParams).toString();
    return Network.request(`${url}?${params}`, {
      loading: true,
      ...options,
    });
  };
export const setShopifyIntegrations = (payload) => ({
  type: at.SET_SHOPIFY_INTEGRATIONS,
  payload,
});
export const getShopifyIntegrations = () => () => {
  const url = `${apiUrlECommerce.shopifyGetIntegration}/`;

  return Network.request(url, {
    loading: true,
    onSuccess: setShopifyIntegrations,
  });
};

export const postShopifyIntegrationCallback =
  (queryParams, options = {}) =>
  () => {
    const url = `${apiUrlECommerce.shopifyGetIntegration}`;
    const params = new URLSearchParams(queryParams).toString();
    return Network.request(`${url}?${params}`, {
      method: "POST",
      loading: true,
      ...options,
    });
  };

/** @type {(id: number) => Promise<{ deep_link: string }>} */
export const getShopifyDeepLink = (id) => () => {
  const url = `${apiUrlECommerce.shopifyGetDeepLink.format(id)}`;

  return Network.request(url, {
    loading: true,
  });
};
/**
 * @type {(id: number) => Promise<{
 *   subscription: {
 *     id: number;
 *     pricing_plan: {
 *       id: number;
 *       name: string;
 *       handle: string;
 *       interval: string;
 *       price: string;
 *       currency: string;
 *       free_trial_days: number;
 *       limits: {
 *         id: number;
 *         pricing_plan: number;
 *         usage_type: string;
 *         limit: null;
 *         limit_type: string;
 *         interval: string;
 *       }[];
 *     };
 *     subscription_id: string;
 *     shopify_integration: number;
 *     status: string;
 *     current_period_end: string;
 *     free_trial_days: number;
 *     updated_at: string;
 *     created_at: string;
 *   };
 *   plan_page_link: string;
 *   deep_link: string;
 * }>}
 */
export const getShopifySubscription = (id) => () => {
  const url = `${apiUrlECommerce.getShopifySubscription.format(id)}`;

  return Network.request(url, {
    loading: true,
  });
};
//#endregion
